import React from 'react'

export default function Picture() {
  return (
    <div className='center'>
      <img src='/img/mesmol_smoller.png' className='headerImage' alt='its a me'/>
    </div>
  )
}
